import { render, staticRenderFns } from "./TreeTypeFormComponent.vue?vue&type=template&id=5856ea0a&scoped=true"
import script from "./TreeTypeFormComponent.vue?vue&type=script&lang=js"
export * from "./TreeTypeFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5856ea0a",
  null
  
)

export default component.exports